<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="4" md="4" lg="4" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')">
        <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data"
                    ref="districtCodeInput"></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2" v-if="!$hasAuthor('ROLE_WARD')">
        <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseInput
          :options="deviceCodeInput.options"
          :data="deviceCodeInput.data"
          :listener="deviceCodeInput.listener"
        />
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseSelect
          :options="activeStatusSelect.options"
          :data="activeStatusSelect.data"
          ref="activeStatusSelect"
        ></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseSelect
          :options="connectStatusSelect.options"
          :data="connectStatusSelect.data"
          ref="connectStatusSelect"
        ></BaseSelect>
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;&nbsp; Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >

          <template #index="{index}">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #updateDate="{item}">
            <td>{{ $helper.formatDate(item.updateDate) }}</td>
          </template>
          <template #activeStatus="{item}">
            <td>
              <span class="badge badge-success" v-if="item.activeStatus == 1">Hoạt động</span>
              <span class="badge badge-danger" v-else>Không hoạt động</span>
            </td>
          </template>
          <template #connectStatus="{item}">
            <td>
              <span class="badge badge-success" v-if="item.connectStatus == 1">Kết nối</span>
              <span class="badge badge-danger" v-else>Mất kết nối</span>
            </td>
          </template>
          <template #volumn="{item}">
            <td>
              {{item.volumn + '%'}}
            </td>
          </template>

        </BaseTable>
      </CCardBody>
    </CCard>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>
  </div>
</template>

<script>
import BaseTable from "../../base/BaseDataTable";
import ModalConfirm from "../../base/BaseModalConfirm";
import BaseInput from "../../base/BaseInput";
import BaseSelect from "../../base/BaseSelect2"
import {LOCATION_CODE_NAME} from "@/constant";

export default {
  name: "ScreenDeviceList",
  components: {
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();
    return {
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          fileSelectedId: null,
          fileSelectedName: null,
          listDeviceSelectedId: []
        }
      },
      deviceCodeInput: {
        options: {
          placeholder: "Mã thiết bị",
          label: 'Mã thiết bị'
        },
        data: {
          name: "deviceCode",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      connectStatusSelect: {
        options: {
          filter: false,
          label: "Trạng thái kết nối",
        },
        data: {
          name: "connectStatus",
          items: [
            {key: "null", value: "Tất cả trạng thái"},
            {key: "0", value: "Mất kết nối"},
            {key: "1", value: "Kết nối"},
          ],
          model: "null",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      activeStatusSelect: {
        options: {
          filter: false,
          label: "Trạng thái hoạt động",
        },
        data: {
          name: "activeStatus",
          items: [
            {key: "null", value: "Tất cả trạng thái"},
            {key: "0", value: "Không hoạt động"},
            {key: "1", value: "Hoạt động"},
          ],
          model: "null",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_PROVINCE')) ? false : true
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {}
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: this.$hasAuthor('ROLE_DISTRICT') ? false : true,
          disabled: this.$hasAuthor('ROLE_DISTRICT') ? false : true
        },
        data: {
          name: "wardCode",
          model: null,
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },
      mainTable: {
        options: {
          fields: [
            {key: "index", label: "STT"},
            {key: "updateDate", label: "Cập nhật cuối"},
            {key: "deviceCode", label: "Mã thiết bị"},
            {key: "activeStatus", label: "Trạng thái hoạt động"},
            {key: "connectStatus", label: "Trạng thái kết nối"},
            {key: "volumn", label: "Âm lượng"},
            {key: "description", label: "Mô tả"},
            {key: "locationName", label: "Địa bàn"},
          ],
          slots: ["index", "updateDate", "activeStatus", "connectStatus", "volumn"],
          lazyLoad: this.$hasAuthor('ROLE_WARD') ? true : false
        },
        dataSource: {
          url: "/screen-device/getPages",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    'districtCodeInput.data.model': function (value) {
      if (value) {
        this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        this.wardCodeInput.options.disabled = false;
      } else {
        this.wardCodeInput.data.items = [];
        this.wardCodeInput.options.disabled = true;
      }
      this.wardCodeInput.data.model = null
    },
    'wardCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
    }
  },
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
